export default __webpack_public_path__ + "static/media/gallery_03.e3f6aee2.jpg";